interface AcornIconProps {
  className?: string;
  size?: number;
}

export const AcornIcon = ({ className = '', size = 32 }: AcornIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Little stars */}
    <g opacity="0.7">
      {/* Top-left star */}
      <path
        d="M5 8l1.2 2.4L8.6 11.6l-2.4 1.2L5 15.2l-1.2-2.4L1.4 11.6l2.4-1.2z"
        fill="currentColor"
        opacity="0.5"
      />
      {/* Top-right star */}
      <path
        d="M58 6l1 2 2 1-2 1-1 2-1-2-2-1 2-1z"
        fill="currentColor"
        opacity="0.4"
      />
      {/* Bottom-left star */}
      <path
        d="M3 46l0.6 1.2 1.2 0.6-1.2 0.6L3 49.6l-0.6-1.2-1.2-0.6 1.2-0.6z"
        fill="currentColor"
        opacity="0.25"
      />
    </g>

    {/* Back acorn (offset left+up, rotated, faded) */}
    <g transform="rotate(-22, 24, 30)" opacity="0.4">
      {/* Cap top */}
      <path
        d="M16 22C16 22 18 15 24 15C30 15 32 22 32 22"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        fill="none"
      />
      {/* Cap brim */}
      <path
        d="M14.5 23.5C14.5 23.5 16.5 20.5 24 20.5C31.5 20.5 33.5 23.5 33.5 23.5"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        fill="none"
      />
      {/* Stem */}
      <path
        d="M24 15C24 15 22.5 10 25 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
      {/* Body */}
      <path
        d="M15 25C15 25 14 36 17 41C20 46 24 47.5 24 47.5C24 47.5 28 46 31 41C34 36 33 25 33 25"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>

    {/* Front acorn (offset right+down, slight tilt) */}
    <g transform="translate(6, 4) rotate(-10, 32, 32)">
      {/* Cap top */}
      <path
        d="M22 22C22 22 24 15 32 15C40 15 42 22 42 22"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Cap crosshatch texture */}
      <path
        d="M23.5 20C23.5 20 26.5 17 32 17C37.5 17 40.5 20 40.5 20"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        fill="none"
        opacity="0.4"
      />
      {/* Cap brim */}
      <path
        d="M20 24C20 24 22 21 32 21C42 21 44 24 44 24"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Stem */}
      <path
        d="M32 15C32 15 30 9 33 7"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        fill="none"
      />
      {/* Body */}
      <path
        d="M21 25.5C21 25.5 20 38 23 43.5C26 49 32 51 32 51C32 51 38 49 41 43.5C44 38 43 25.5 43 25.5"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Body highlight line */}
      <path
        d="M28.5 29C28.5 33 30.5 42 32 45"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        opacity="0.3"
      />
    </g>
  </svg>
);
